export default function (element) {
    let activeForm = null;

    function closePopup() {
        if (!activeForm) return;

        activeForm.classList.remove('open');
        document.body.classList.remove('no-scroll');
        activeForm = null;
    }

    function openPopup(itemData) {
        closePopup();

        const form = element.querySelector(`#${itemData.type}`);
        if (!form) return;

        if (itemData.product_id) {
            const input = form.querySelector('input[name="product_id"]');
            if (input) input.value = itemData.product_id;
        }

        if (itemData.project_id) {
            const input = form.querySelector('input[name="project_id"]');
            if (input) input.value = itemData.project_id;
        }

        form.classList.add('open');
        document.body.classList.add('no-scroll');
        activeForm = form;
    }

    window.addEventListener('open-popup-form', (e) => {
        if (!e.detail?.dataset) return;
        openPopup(e.detail.dataset);
    });

    window.addEventListener('close-popup-form', closePopup);

    element.addEventListener('click', (e) => {
        if (!activeForm) return;

        if (e.target.closest('.close-btn')) {
            closePopup();
        }

        if (e.target === activeForm) {
            closePopup();
        }
    });
}
